import React from "react";

type ProjectRequirementContextType = {
  projectId: string;
  requirementId: string;
  hasItemAnyQuestions: (itemId: string) => boolean;
  refetchWizardQuestions: () => Promise<void>;
};

export const ProjectRequirementContext = React.createContext<
  ProjectRequirementContextType | undefined
>(undefined);

export const useProjectRequirementContext = () => {
  const context = React.useContext(ProjectRequirementContext);
  if (!context) {
    throw new Error(
      "useProjectRequirementContext must be used within a ProjectRequirementContextProvider"
    );
  }

  return context;
};
